module.exports = __webpack_public_path__ + "assets/img/d185-aw.svg";